import { render, staticRenderFns } from "./chart-levels.vue?vue&type=template&id=108bfae0"
import script from "./chart-levels.vue?vue&type=script&lang=ts"
export * from "./chart-levels.vue?vue&type=script&lang=ts"
import style0 from "./chart-levels.vue?vue&type=style&index=0&id=108bfae0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports